import clsx from "clsx";
import React, { AnchorHTMLAttributes } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import environment from "web/script/modules/environment";
import {
    CategoryFilterOption,
    isFilterSection,
    UniversalFilterSection,
} from "web/types/universal-filters";
import styles from "./chevron-filter-item.module.css";

interface ChevronFilterItemProps {
    item: UniversalFilterSection | CategoryFilterOption;
    onClick: (item: UniversalFilterSection | CategoryFilterOption) => void;
    large: boolean;
    expanded: boolean;
    subText?: string;
    ariaControls?: string;
}

function ChevronFilterItem({
    ariaControls,
    expanded,
    item,
    large,
    onClick,
    subText,
}: ChevronFilterItemProps): JSX.Element {
    function handleClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        onClick(item);
    }
    let href: string | null;
    let label: string;

    if (isFilterSection(item)) {
        href = null;
        label = item.title;
    } else {
        href = item.url;
        label = item.label;
    }

    const anchorAttributes: AnchorHTMLAttributes<HTMLAnchorElement> = {
        tabIndex: 0,
        className: clsx(styles.filterItem, { [styles.largeItem]: large }),
        onClick: handleClick,
        role: "button",
        "aria-expanded": expanded,
        "aria-controls": ariaControls,
    };

    if (href) {
        anchorAttributes.href = href;
    }

    return (
        <a {...anchorAttributes}>
            <span className={styles.text}>
                {!large ? (
                    <span
                        className={clsx(styles.radioButton, {
                            [styles.radioButtonChecked]: item.type == "category" && item.checked,
                        })}
                    >
                        {item.type == "category" && item.checked ? (
                            <SVGIcon name={"round-radiobutton-checked"} />
                        ) : (
                            <SVGIcon name={"round-radiobutton"} />
                        )}
                    </span>
                ) : null}
                <span
                    className={styles.label}
                    id={ariaControls ? `${ariaControls}-header` : undefined}
                >
                    {label}
                </span>
                {subText && (
                    <span
                        aria-hidden
                        className={clsx(styles.subText, { [styles.hidden]: expanded })}
                    >
                        {subText}
                    </span>
                )}
            </span>
            {environment.getFeature("seo_enable_relevant_feed_filters") &&
            item.type === "category" ? null : (
                <SVGIcon
                    className={clsx(styles.icon, { [styles.rotate]: expanded })}
                    name="square-chevron-thin"
                />
            )}
        </a>
    );
}

export default ChevronFilterItem;
